<template>
  <div>
    <h3 class="page__title">订单统计报表</h3>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
        <div class="weui-cell__hd">
            <label class="weui-label">开始日期</label>
        </div>
        <div class="weui-cell__bd" @click="pickerStartDate" >
          <a style="align-text:left ;color: #238E23;">{{dateStartStr}}</a>
        </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
      <div class="weui-cell__hd">
        <label class="weui-label">截止日期</label>
      </div>
      <div class="weui-cell__bd" @click="pickerDate">
        <a style="align-text:left ;color: #238E23;">{{ dateStr }}</a>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="color: black">
      <div class="weui-cell__hd">
        <label class="weui-label">网点</label>
      </div>
      <div class="weui-cell__bd" @click="pickPos">
        <a style="align-text:left;color: #238E23;">{{ posSelected.label }}</a>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_vcode" style="display: none;">
      <div class="weui-cell__hd">
        <label class="weui-label">追溯天数</label>
      </div>
      <div class="weui-cell__bd" @click="pickMasterDay">
        <a style="align-text:left;color: #238E23;">{{ this.MasterDay }}</a>
      </div>

    </div>
    <hr />
    <div class="table-responsive">
      <table class="table table-striped " style="font-size: small;">
        <thead>
          <tr>
            <th scope="col">日期范围</th>
            <th scope="col">已服务</th>
            <th scope="col">已退款</th>
            <th scope="col">待服务</th>
            <th scope="col">未支付</th>

          </tr>
        </thead>
        <tbody>
          <tr>
            <th scope="row" @click="switchDetail(ALLrptdata.date)">{{ this.dateStr }}至<br>{{ this.ALLrptdata.date }}</th>
            <td @click="toDir(ALLrptdata.date, 3)" style="text-decoration:underline">{{ this.ALLrptdata.completeCount }}</td>
            <td @click="toDir(ALLrptdata.date, 4)" style="text-decoration:underline">{{ this.ALLrptdata.refundCount }}</td>
            <td @click="toDir(ALLrptdata.date, 2)" style="text-decoration:underline">{{ this.ALLrptdata.payedCount }}</td>
            <td @click="toDir(ALLrptdata.date, 1)" style="text-decoration:underline">{{ this.ALLrptdata.waitCount }}</td>
          </tr>
          <tr :name="ALLrptdata.date" v-show="ALLrptdata.detailFlag">
            <td style="white-space:nowrap;">微信</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.completeAmount }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.refundAmount }} </td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.payedAmount }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.waitAmount }}</td>
          </tr>
          <tr :name="ALLrptdata.date" v-show="ALLrptdata.detailFlag">
            <td style="white-space:nowrap;">余额</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.completeBalance }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.refundBalance }} </td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.payedBalance }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.waitBalance }}</td>
          </tr>
          <tr :name="ALLrptdata.date" v-show="ALLrptdata.detailFlag">
            <td style="white-space:nowrap;">链点</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.completePoint }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.refundPoint }} </td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.payedPoint }}</td>
            <td style="white-space:nowrap;">￥{{ ALLrptdata.waitPoint }}</td>
          </tr>

        </tbody>
      </table>
    </div>


    <div class="table-responsive panel-footer" style="height: 35vh;overflow: auto;" v-if="reportData.length > 0">
      <span>订单笔数按状态分布                 可点击单元格以跳转具体信息</span>
      <table class="table table-striped " style="font-size: small;">
        <thead>
          <tr>
            <th scope="col">日期</th>
            <th scope="col">已服务</th>
            <th scope="col">已退款</th>
            <th scope="col">待服务</th>
            <th scope="col">未支付</th>
          </tr>
        </thead>
        <tbody v-for="itm in reportData" :key="itm.date">
          <tr>
            <th scope="row" @click="switchDetail(itm.date)">{{ itm.date }} <svg xmlns="http://www.w3.org/2000/svg"
                width="16" height="16" fill="currentColor" class="bi bi-chevron-compact-down" viewBox="0 0 16 16">
                <path fill-rule="evenodd"
                  d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z" />
              </svg> </th>
            <td style="white-space:nowrap; text-decoration:underline" @click="toDir(itm.date, 3)" > {{ itm.completeCount }}</td>
            <td style="white-space:nowrap; text-decoration:underline" @click="toDir(itm.date, 4)">{{ itm.refundCount }}</td>
            <td style="white-space:nowrap; text-decoration:underline" @click="toDir(itm.date, 2)"> {{ itm.payedCount }}</td>
            <td style="white-space:nowrap; text-decoration:underline" @click="toDir(itm.date, 1)">{{ itm.waitCount }}</td>
          </tr>
          <!--
                  <tr >
                    <td style="white-space:nowrap;">总额</td>
                    <td style="white-space:nowrap;">￥{{itm.completePrice.toFixed(2)}}</td>
                    <td style="white-space:nowrap;">￥{{itm.refundPrice}} </td>
                    <td style="white-space:nowrap;">￥{{itm.payedPrice}}</td>
                    <td style="white-space:nowrap;">￥{{itm.waitPrice}}</td>
                  </tr>-->
          <tr :name="itm.date" v-show="itm.detailFlag">
            <td style="white-space:nowrap;">微信</td>
            <td style="white-space:nowrap;">￥{{ itm.completeAmount }}</td>
            <td style="white-space:nowrap;">￥{{ itm.refundAmount }} </td>
            <td style="white-space:nowrap;">￥{{ itm.payedAmount }}</td>
            <td style="white-space:nowrap;">￥{{ itm.waitAmount }}</td>
          </tr>
          <tr :name="itm.date" v-show="itm.detailFlag">
            <td style="white-space:nowrap;">余额</td>
            <td style="white-space:nowrap;">￥{{ itm.completeBalance }}</td>
            <td style="white-space:nowrap;">￥{{ itm.refundBalance }} </td>
            <td style="white-space:nowrap;">￥{{ itm.payedBalance }}</td>
            <td style="white-space:nowrap;">￥{{ itm.waitBalance }}</td>
          </tr>
          <tr :name="itm.date" v-show="itm.detailFlag">
            <td style="white-space:nowrap;">链点</td>
            <td style="white-space:nowrap;">￥{{ itm.completePoint }}</td>
            <td style="white-space:nowrap;">￥{{ itm.refundPoint }} </td>
            <td style="white-space:nowrap;">￥{{ itm.payedPoint }}</td>
            <td style="white-space:nowrap;">￥{{ itm.waitPoint }}</td>
          </tr>

        </tbody>
      </table>

    </div>

    <div id="loadingToast" style="display: none;" v-else-if="ing">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <span class="weui-primary-loading weui-primary-loading_transparent weui-icon_toast">
          <span class="weui-primary-loading__dot"></span>
        </span>
        <p class="weui-toast__content">加载中</p>
      </div>
    </div>
    <div class="weui-msg" v-else>
      <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
      <div class="weui-msg__text-area">
        <h2 class="weui-msg__title">没有订单</h2>
        <p class="weui-msg__desc">指定查询条件未检索到订单，请修改查询条件。</p>
      </div>
    </div>
    <div role="alert" class="weui-toptips weui-toptips_warn" id="warnToast">获取数据失败</div>
    <div role="alert" class="weui-toptips weui-toptips_warn" id="timeWarnToast">日期选择有误</div>
    <pieGraph ref="chart_line_box" style="height:300px" />

  </div>
</template>

<script>
import pieGraph from '../components/pie.vue'

import 'bootstrap/dist/css/bootstrap.css'

import JQ from 'jquery'

import axios from 'axios'
import { forEach } from 'emojis-list'

function get2Str(str) {
  return padding1(str, 2);
}
function padding1(num, length) {
  for (var len = (num + "").length; len < length; len = num.length) {
    num = "0" + num;
  }
  return num;
}
export default {

  data() {
    return {
      ing: true,
      partnerid: "",
      posSelected: {
        label: '所有',
        value: 0
      },
      posList: [{
        label: '所有',
        value: 0
      }],
      //date: new Date(),
      //dateStr: new Date().Format("yyyy-MM-dd"),
      date:this.$moment(new Date(),'YYYY-MM-01').startOf('month'),
      dateStartStr : this.$moment(new Date(),'YYYY-MM-01').format('YYYY-MM-01') ,
      dateEnd:this.$moment(new Date()).endOf('day') ,
      dateStr : new Date().Format("yyyy-MM-dd") ,
      reportData: [],
      Daylist: [],
      MasterDay: '',
      ALLrptdata: []

    }
  },
  mounted() {
    const { name, xData, yData } = this
    console.log(this.$refs)
    console.log(this.partnerid, sessionStorage.getItem("partnerid"))
    this.partnerid = sessionStorage.getItem("partnerid")
    console.log(this.partnerid, sessionStorage.getItem("partnerid"))
    // this.$refs.chart_line_one.initChart(name,xData,yData)
    this.creatDaylist()
    this.initPosList(this.partnerid);
    this.init();
    this.getReport();


  },
  components: {
    pieGraph
  },
  methods: {
    init(){
      console.log(this.date,"-------------------------------------------------------------------------");
      console.log(this.dateEnd);

      const dayNum = this.dateEnd.diff(this.date,'days')+1;
      console.log(dayNum);
      this.MasterDay = dayNum;
      this.getReport();

    },

    creatDaylist() {

      for (let num = 2; num < 32; num++) {
        this.Daylist.push(num)
      }

      console.log(this.Daylist)
    },
    pickMasterDay() {
      let that = this;
      this.$weui.picker(this.Daylist, {
        onChange: function (result) {
          console.log(result);

        },
        onConfirm: function (result) {
          console.log(result);

          that.MasterDay = result[0]
          that.MasterDay = that.MasterDay.value
          console.log(that.MasterDay)
          that.getReport();


        },
        title: '选择网点'
      });
    },
    toDir(date, state) {
      this.$router.push({
        name: "orderlist", params: {
          dateStr: date,
          state: state,
          posid: this.posSelected.value
        }
      });
    },
    switchDetail(idx) {
      console.log("switchDetail", idx)
      // itm.detailFlag = !itm.detailFlag;
      let display_attr = JQ("tr[name='" + idx + "']").css('display');
      if (display_attr != "none")
        JQ("tr[name='" + idx + "']").css('display', 'none')
      else
        JQ("tr[name='" + idx + "']").css('display', '')
      console.log(display_attr)
    },

    initPosList(pid) {
      let pelist = JSON.parse(sessionStorage.getItem("posListOf_" + pid));

      console.log(pelist, pid)

      pelist.forEach(item => {
        let tmp = {};
        tmp.label = item.name;
        tmp.value = item.posId;

        this.posList.push(tmp);
      });

      /*
      this.posList.push({
           label: '所有',
           value: 0
       });*/

    },
    pickerStartDate() {
      let that = this;
      this.$weui.datePicker({
            start: 2022,
            end: new Date().getFullYear(),
       /*      onChange: function (result) {
                console.log(result);
                console.log(result[0].value +"-"+ result[1].value +"-"+ result[2].value );
            }, */
            onConfirm: function (result) {

                console.log(result);
                that.dateStartStr = result[0].value +"-"+ get2Str(result[1].value) +"-"+ get2Str(result[2].value);
                if(that.$moment(that.dateStartStr, 'YYYY-MM-DD')>that.dateEnd){
                  that.showTimeError();
                  return;
                };
                that.date =that.$moment(that.dateStartStr, 'YYYY-MM-DD');
                that.init();
                that.getReport();

            },
            title: '请选择开始日期'
        });
    },
    pickerDate() {
      let that = this;
      this.$weui.datePicker({
        start: 2022,
        end: new Date().getFullYear(),
        onChange: function (result) {
          console.log(result);
          // console.log(result[0].value + "-" + result[1].value + "-" + result[2].value);
          // that.dateStr = result[0].value + "-" + get2Str(result[1].value) + "-" + get2Str(result[2].value);
        },
        onConfirm: function (result) {
          that.dateStr = result[0].value + "-" + get2Str(result[1].value) + "-" + get2Str(result[2].value);
          console.log(result,that.dateEndStr);
          if(that.$moment(that.dateStr, 'YYYY-MM-DD')<that.date){
            that.showTimeError();
            return;
          }
          that.dateEnd =that.$moment(that.dateStr, 'YYYY-MM-DD');

          that.init();
          that.getReport();

        },
        title: '请选择结束日期'
      });
    },
    showTimeError() {
      var $warnToast = JQ('#timeWarnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
        $warnToast.fadeOut(100);
      }, 2000);
    },
    showError() {
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
        $warnToast.fadeOut(100);
      }, 2000);
    },
    fillDays7() {
      let mapReport = new Map();
      mapReport.clear();

      let val_org = {
        "date": "",
        "detailFlag": false,
        "completeCount": 0,
        "completePrice": 0.0,
        "completeAmount": 0.0,
        "completePoint": 0.0,
        "completeBalance": 0.0,
        "refundCount": 0,
        "refundPrice": 0.0,
        "refundAmount": 0.0,
        "refundPoint": 0.0,
        "refundBalance": 0.0,
        "payedCount": 0,
        "payedPrice": 0.0,
        "payedAmount": 0.0,
        "payedPoint": 0.0,
        "payedBalance": 0.0,
        "waitCount": 0,
        "waitPrice": 0.0,
        "waitAmount": 0.0,
        "waitPoint": 0.0,
        "waitBalance": 0.0,
      };
      let lDay = this.$moment(this.dateStr, 'YYYY-MM-DD');

      console.log(lDay)

      let cnt = this.MasterDay;
      while (cnt >= 1) {
        let val = new Map();

        for (var key in val_org) {
          val[key] = val_org[key];
        }
        val['date'] = lDay.format('YYYY-MM-DD');
        console.log(val);

        mapReport[lDay.format('YYYY-MM-DD')] = val;
        cnt--;

        lDay = lDay.subtract(1, 'days')

//        console.log(cnt, lDay, lDay.format('YYYY-MM-DD'))


      }

    //  console.log(mapReport)

      return mapReport;

    },
    pickPos() {
      let that = this;
      this.$weui.picker(this.posList, {
        onChange: function (result) {
          console.log(result);
          that.posSelected = result[0]
        },
        onConfirm: function (result) {
          console.log(result);
          that.getReport(that.dateStr);
        },
        title: '选择网点'
      });
    },

    getReport()  {
       //const dayNum = this.dateEnd.diff(this.date,'days')+1;
      let paras = {
        pid: this.partnerid,
        date : this.dateStr + " 23:59:59",
        daynum: Number(this.MasterDay),
      };

      if (this.posSelected.value != 0) paras.posid = this.posSelected.value;

      let that = this;
      that.ing = true;
      axios.get('/zmomc/orderDailyReport', {
        params: paras
      }).then(res => {
        console.log(res.data)


        if ((res.data == null)) {
          that.showError(); return;
        }

        if (res.data.length == 0) {
          // alert("选定的日期没有数据");
          that.reportData = [];
          that.$refs.chart_line_box.initChart(that.dateStr, [])
          return;
        }

        let mapReport = this.fillDays7();
        //console.log("AAAAAAAAAA", mapReport)
        res.data.forEach(item => {
         // console.log(item);

          let val = mapReport[item.odate];

          if (val) {

           // console.log("item", item, "val", val);

            val.date = item.odate;
            if ((item.ostate == 3)) {
              val.completeCount += item.ocount;
              val.completeAmount += item.oamount;
              val.completeBalance += item.obalance;
              val.completePoint += item.opoint;
              val.completePrice += item.oamount + item.obalance + item.opoint;
            }
            else if ((item.ostate == 4)) {
              val.refundCount += item.ocount;
              val.refundAmount += item.oamount;
              val.refundBalance += item.obalance;
              val.refundPoint += item.opoint;
              val.refundPrice += item.oamount + item.obalance + item.opoint;
            }
            else if ((item.ostate == 2)) {
              val.payedCount += item.ocount;
              val.payedAmount += item.oamount;
              val.payedBalance += item.obalance;
              val.payedPoint += item.opoint;
              val.payedPrice += item.oamount + item.obalance + item.opoint;
            }
            else if ((item.ostate == 1)) {
              val.waitCount += item.ocount;
              val.waitAmount += item.oamount;
              val.waitBalance += item.obalance;
              val.waitPoint += item.opoint;
              val.waitPrice += item.oamount + item.obalance + item.opoint;
            }
          }
        })

        console.log(mapReport)
        var arrayObj = [];
        for (var keName in mapReport) {
          if (keName.length != 10) continue;
          arrayObj.push(mapReport[keName])
        }
        console.log(arrayObj)

        let rptData = [];
        let itmRptDataComplete = { "name": "已服务", "value": arrayObj[0].completeCount };
        let itmRptDataRefund = { "name": "已退款", "value": arrayObj[0].refundCount };
        let itmRptDataPayed = { "name": "待服务", "value": arrayObj[0].payedCount };
        let itmRptDataWait = { "name": "待支付", "value": arrayObj[0].waitCount };

        rptData.push(itmRptDataComplete);
        rptData.push(itmRptDataRefund);
        rptData.push(itmRptDataPayed);
        rptData.push(itmRptDataWait);


        that.reportData = arrayObj
        console.log(that.reportData)
        console.log(rptData)
        this.$refs.chart_line_box.initChart(arrayObj[0].date, rptData)
        console.log('add--------------------------------------------------------------------')
        console.log(that.reportData)

        let date = 0
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        that.reportData.forEach(item => {
          num1 += parseFloat(item.completeCount)
          num2 += parseFloat(item.refundCount)
          num3 += parseFloat(item.payedCount)
          num4 += parseFloat(item.waitCount)
          date = item.date
        })
        this.ALLrptdata.completeCount = num1
        this.ALLrptdata.refundCount = num2
        this.ALLrptdata.payedCount = num3
        this.ALLrptdata.waitCount = num4
        this.ALLrptdata.date = date
        // 微信
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        that.reportData.forEach(item => {
          num1 += parseFloat(item.completeAmount)
          num2 += parseFloat(item.refundAmount)
          num3 += parseFloat(item.payedAmount)
          num4 += parseFloat(item.waitAmount)

        })
        this.ALLrptdata.completeAmount = num1.toFixed(2)
        this.ALLrptdata.refundAmount = num2.toFixed(2)
        this.ALLrptdata.payedAmount = num3.toFixed(2)
        this.ALLrptdata.waitAmount = num4.toFixed(2)
        console.log(that.ALLrptdata)
        // 余额
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        that.reportData.forEach(item => {
          num1 += parseFloat(item.completeBalance)
          num2 += parseFloat(item.refundBalance)
          num3 += parseFloat(item.payedBalance)
          num4 += parseFloat(item.waitBalance)

        })
        this.ALLrptdata.completeBalance = num1.toFixed(2)
        this.ALLrptdata.refundBalance = num2.toFixed(2)
        this.ALLrptdata.payedBalance = num3.toFixed(2)
        this.ALLrptdata.waitBalance = num4.toFixed(2)
        console.log(that.ALLrptdata)
        // 链点
        var num1 = 0
        var num2 = 0
        var num3 = 0
        var num4 = 0
        that.reportData.forEach(item => {
          num1 += parseFloat(item.completePoint)
          num2 += parseFloat(item.refundPoint)
          num3 += parseFloat(item.payedPoint)
          num4 += parseFloat(item.waitPoint)

        })
        this.ALLrptdata.completePoint = num1.toFixed(2)
        this.ALLrptdata.refundPoint = num2.toFixed(2)
        this.ALLrptdata.payedPoint = num3.toFixed(2)
        this.ALLrptdata.waitPoint = num4.toFixed(2)
        this.ALLrptdata.detailFlag = false
        console.log(that.ALLrptdata)











        that.ing = false;
      })

    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/report_order.vue